import axios from 'axios';

export async function updateCard(token, cnpj) {
    try {
        const url = process.env.VUE_APP_APIURL;
        const cardResponse = await axios.post(`${url}/pagamentos/sitef/updateCard`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                body: {token, cnpj}
            },
        });
        return cardResponse
    } catch (error) {
        console.error('Erro ao obter cartões do usuario:', error);
        throw new Error('Erro ao obter cartões do usuario:', error);
    }
}